import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

export const Navbar = () => {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { to: "/shop", label: "Shop" },
    { to: "/#story", label: "Story" },
    { to: "/#manifesto", label: "Ethos" },
  ];

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      data-testid="navbar"
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-500 ${scrolled || pathname !== "/" ? "bg-[#EDEEF1]/90 backdrop-blur-md border-b border-[#D4D7DD] text-[#0B0E14]" : "bg-transparent text-[#EDEEF1]"}`}
    >
      <nav className="w-full mx-auto px-4 sm:px-8 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <div className="flex-1 hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.label} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`} className="label link-underline">
              {l.label}
            </Link>
          ))}
        </div>
        <Link to="/" data-testid="nav-logo" className="flex-1 md:flex-none text-center leading-none">
          <span className="font-bodoni text-2xl md:text-3xl tracking-tight">FUNKY<span className="volt">.</span></span>
          <span className="hidden md:block label text-[0.5rem] tracking-[0.4em] mt-0.5 opacity-70">APPAREL</span>
        </Link>
        <div className="flex-1 flex items-center justify-end gap-6">
          <Link to="/shop" className="label link-underline hidden md:inline">Collection</Link>
          <button data-testid="cart-button" onClick={() => setOpen(true)} className="relative flex items-center gap-2 group">
            <ShoppingBag className="w-5 h-5" strokeWidth={1.3} />
            <AnimatePresence>
              {count > 0 && (
                <motion.span
                  key={count}
                  initial={{ scale: 0 }} animate={{ scale: 1 }} exit={{ scale: 0 }}
                  data-testid="cart-count"
                  className="absolute -top-2 -right-3 bg-[#0B0E14] text-[#EDEEF1] text-[10px] w-4 h-4 flex items-center justify-center rounded-full"
                >
                  {count}
                </motion.span>
              )}
            </AnimatePresence>
          </button>
        </div>
      </nav>
    </motion.header>
  );
};
